import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import FlickityWidget from './FlickityWidget';
import LoadingPage from '../LoadingPage';
import Chart from '../../util/chart';
import ReportWidget from './ReportWidget';
import { convertToArrayOfObjects } from '../../util/report';

class WEBPI2AllWidget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sales: {},
      salesByPPC: {},
      isReady: false,
    };

    this.sales = {
      'Front Counter': {
        name: 'Front Counter',
        total: 0.0,
        profit: 0.0,
      },
      'Back Counter': {
        name: 'Back Counter',
        total: 0.0,
        profit: 0.0,
      },
    };
  }

  getTodaysDate() {
    // Use date in past to get data in dev
    return process.env.NODE_ENV === 'development' ? '01-13-17' : moment().format('MM-DD-YY');
  }

  handleData = ({ data, cols }) => {
    // transform array of positional data to array of json objects
    data = convertToArrayOfObjects(data, cols);

    const sales = _.cloneDeep(this.sales);
    data.forEach(row => {
      if (row.profitt && row.extd) {
        sales[row.typ].profit += parseFloat(row.profitt);
        sales[row.typ].total += parseFloat(row.extd);
      }
    });

    const ret = {};
    data.forEach(row => {
      if (!row.Initials) {
        row.Initials = 'Other';
      }

      if (!row.sles) {
        return;
      }

      if (!ret[row.Initials]) {
        ret[row.Initials] = 0;
      }
      ret[row.Initials] += parseFloat(row.sles);
    });

    const sortedKeys = Object.keys(ret).sort((a, b) => {
      return ret[b] - ret[a];
    });

    const salesByPPC = [];
    let len;
    let other = 0;

    if (sortedKeys.length >= 19) {
      len = 9;
      for (let i = 20; i < sortedKeys.length; i++) {
        other += ret[sortedKeys[i]];
      }
    } else {
      len = sortedKeys.length;
    }

    for (let i = 0; i < len; i++) {
      salesByPPC.push({
        label: sortedKeys[i],
        value: ret[sortedKeys[i]],
      });
    }

    if (other) {
      salesByPPC.push({
        label: 'Other',
        value: other,
      });
    }

    this.setState({ salesByPPC, sales, isReady: true }, this.renderCharts);
  };

  renderCharts() {
    Chart.makeBarChart('webpi2all-widget-chart-1', {
      titles: [
        {
          text: 'Sales and Profit (Today) For All Stores',
        },
      ],
      dataProvider: [this.state.sales['Front Counter'], this.state.sales['Back Counter']],
      valueAxes: [
        {
          unit: '$',
          unitPosition: 'left',
        },
      ],
      graphs: [
        Chart.getBarGraph({
          balloonText: 'Sales for [[category]]: $[[value]]',
          title: 'Sales',
          valueField: 'total',
          fillColors: ['#03A9F4'],
        }),
        Chart.getBarGraph({
          balloonText: 'Profit for [[category]]: $[[value]]',
          title: 'Profit',
          valueField: 'profit',
          fillColors: ['#81C784'],
        }),
      ],
      rotate: true,
      categoryField: 'name',
      categoryAxis: {
        gridPosition: 'start',
        fillAlpha: 0.05,
        position: 'left',
      },
    });

    Chart.makePieChart('webpi2all-widget-chart-2', {
      titles: [
        {
          text: 'Sales by Initials (Today)',
        },
      ],
      dataProvider: this.state.salesByPPC,
      balloonText: '<span style="font-size:14px">[[title]]<br><b>$[[value]]</b> ([[percents]])</span>',
    });
  }

  render() {
    return (
      <ReportWidget
        pageName="WEBPI2"
        reportOptions={['DAY', this.getTodaysDate(), 'Y', 'Y', 'Y', 'Y']}
        handleData={this.handleData}
      >
        {this.state.isReady ? (
          <FlickityWidget>
            <div id="webpi2all-widget-chart-2" className="carousel-cell" />
            <div id="webpi2all-widget-chart-1" className="carousel-cell" />
          </FlickityWidget>
        ) : (
          <LoadingPage />
        )}
      </ReportWidget>
    );
  }
}

export default WEBPI2AllWidget;
